import './VerticalColumnView.scss';

import { LoadingSpinner } from '@ui/LoadingSpinner';
import { Row } from 'antd';

import React, { PropsWithChildren } from 'react';
import { ViewArea, ViewAreaProps } from '@ui/general';

export type VerticalColumnViewProps = ViewAreaProps & {
	loading?: boolean;
};

export const VerticalColumnView: React.FC<PropsWithChildren<VerticalColumnViewProps>> = ({
	children,
	loading,
	...rest
}) =>
	<ViewArea
		className='vertical-column-view'
		direction='vertical'
		fullWidth
		{ ...rest }>
		<LoadingSpinner spinning={ loading }>
			<div className='vertical-column-view-content'>
				<Row gutter={ 8 }>
					{ children }
				</Row>
			</div>
		</LoadingSpinner>
	</ViewArea>;

